import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Flex } from '#atoms';
import { useEducationFormState } from '../OnBoardSearchEducation.hooks';

type NotFoundEducationProps = {
  name: string;
};

export default function NotFoundEducation({ name }: NotFoundEducationProps) {
  const navigate = useNavigate();
  const { setEducationFormState } = useEducationFormState();
  const enroll = () => {
    setEducationFormState({
      educationIssuerClassId: undefined,
      institution: undefined,
      name
    });
    navigate(-1);
  };
  return (
    <Flex direction="column" align="center">
      <FaceIcon />
      <NotFound>
        <SearchName>'{name}'</SearchName>로 등록된 교육명이 없습니다.
      </NotFound>
      <Question>새로운 교육명으로 등록하시겠어요?</Question>
      <EnrollButton onClick={enroll}>
        <PlusIcon /> 등록하기
      </EnrollButton>
    </Flex>
  );
}

const NotFound = styled.div`
  margin-top: 24px;
  color: ${({ theme }) => theme.palette.gray15};
`;

const SearchName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.brand300};
`;

const Question = styled.div`
  margin-top: 6px;
  color: ${({ theme }) => theme.palette.gray100};
  font-size: 14px;
`;

const EnrollButton = styled.button`
  margin-top: 24px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray400};
  color: ${({ theme }) => theme.palette.brand300};
`;

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M7.83333 8.66683H3.83333V7.3335H7.83333V3.3335H9.16667V7.3335H13.1667V8.66683H9.16667V12.6668H7.83333V8.66683Z"
      fill="#9170F2"
    />
  </svg>
);

const FaceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="56"
    viewBox="0 0 57 56"
    fill="none"
  >
    <path
      d="M28.5 55C43.4117 55 55.5 42.9117 55.5 28C55.5 13.0883 43.4117 1 28.5 1C13.5883 1 1.5 13.0883 1.5 28C1.5 42.9117 13.5883 55 28.5 55Z"
      fill="#24222A"
      stroke="#383441"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M20.0698 34.3006C20.4884 32.3736 21.5539 30.6479 23.0892 29.4104C24.6245 28.1729 26.537 27.498 28.5089 27.498C30.4809 27.498 32.3934 28.1729 33.9287 29.4104C35.4639 30.6479 36.5295 32.3736 36.9481 34.3006"
      stroke="#383441"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M38.2302 23.0332C38.2302 23.1432 38.141 23.2324 38.031 23.2324C37.921 23.2324 37.8318 23.1432 37.8318 23.0332C37.8318 22.9232 37.921 22.834 38.031 22.834C38.141 22.834 38.2302 22.9232 38.2302 23.0332Z"
      fill="#4D495A"
      stroke="#383441"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.1771 23.0332C19.1771 23.1432 19.0879 23.2324 18.9779 23.2324C18.8679 23.2324 18.7787 23.1432 18.7787 23.0332C18.7787 22.9232 18.8679 22.834 18.9779 22.834C19.0879 22.834 19.1771 22.9232 19.1771 23.0332Z"
      fill="#4D495A"
      stroke="#383441"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
